import './index.css'
import './styles/fonts.css'
import React from 'react'
import { ToastContainer } from 'react-toastify';
import ReactDOM from 'react-dom/client'
import App from './App'

const root = ReactDOM.createRoot(document.querySelector("body"))
root.render(
    <React.StrictMode>
        <ToastContainer theme='dark' position='top-center'/>
        <App />
    </React.StrictMode>
)